import * as React from 'react';
import { generatePath, Link } from 'react-router-dom';

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

import { SingularMenuItem } from 'layouts/AppPageTemplate/utils/menus';
import { Region } from 'services/clients/regions';
import { ItemIcon } from 'layouts/AppPageTemplate/desktop/DesktopNav/MenuDropdown/ItemIcon';

interface Props {
  region: Region;
  item: SingularMenuItem;
}

export const Item: React.FC<Props> = (props) => {
  const { region, item } = props;

  const { details } = item.page;
  const to = generatePath(item.page.path, { region: region.route });

  const title = item.overrides?.title || item.page.title;

  return (
    <Link to={to} key={item.page.path}>
      <li
        className={`flex p-3 space-x-3 hover:bg-${details?.hoverColor} border-b border-gray-100 items-start`}
      >
        <ItemIcon page={item.page} />
        <div className="grow space-y-0">
          <p className="font-bold text-gray-800">{title}</p>
          <h4 className="font-medium text-gray-600">{details?.description?.(region)}</h4>
        </div>
        <ArrowRightAltIcon className="self-center" />
      </li>
    </Link>
  );
};
Item.displayName = 'Landing.Menu.Item';
